import React, { FC, ReactNode } from 'react';

import * as amplitude from '@amplitude/analytics-browser';
import { Grid, Stack, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useRouter } from 'next/router';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';

import { ImageVestaLogo } from '~components/shared/images';
import Link, { NormalNextLink } from '~components/shared/link';
import { black, primaryColors } from '~components/theme/styles/colors';

export const TopNavSelection: FC<{ href: string; selected: boolean; children: ReactNode }> = ({
  children,
  href,
  selected,
}) => {
  return (
    <NormalNextLink
      onClick={() => {
        amplitude.track('landing-nav', { type: href });
      }}
      href={href}
      sx={{ textDecoration: 'none' }}
    >
      <Typography
        sx={{
          cursor: 'pointer',
          color: selected ? primaryColors[100] : primaryColors[400],
          transition: 'color 0.08s linear',
          ':hover': { color: primaryColors[100] },
        }}
        variant={'label3'}
      >
        {children}
      </Typography>
    </NormalNextLink>
  );
};

export default function LandingTopNav() {
  const { asPath } = useRouter();
  const smallLogo = useMediaQuery('(max-width:380px)');

  const handleEnterApp = () => {
    amplitude.track('enter-app');
  };

  return (
    <Grid
      container
      sx={{
        height: '101px',
        position: 'fixed',
        background: black['45%'],
        zIndex: 10,
        px: { xs: '32px', md: '144px' },
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Grid item sx={{ width: '180px' }} xs={2}>
        <ImageVestaLogo small={smallLogo} />
      </Grid>

      <Grid item xs={8}>
        <Stack direction={'row'} spacing={4} justifyContent={'center'}>
          <TopNavSelection href={'/'} selected={asPath === '/'}>
            ABOUT
          </TopNavSelection>
          <TopNavSelection href={'/learn'} selected={asPath.search(`^${'/learn'}(.*)`) === 0}>
            LEARN
          </TopNavSelection>
          <TopNavSelection href={'/mission'} selected={asPath.search(`^${'/mission'}(.*)`) === 0}>
            MISSION
          </TopNavSelection>
          <TopNavSelection href={'/governance'} selected={asPath.search(`^${'/governance'}(.*)`) === 0}>
            GOVERNANCE
          </TopNavSelection>
          <TopNavSelection href={'/roadmap'} selected={asPath.search(`^${'/roadmap'}(.*)`) === 0}>
            ROADMAP
          </TopNavSelection>
        </Stack>
      </Grid>

      <Grid item xs={2}>
        <Link prefetch href="/vaults">
          <ButtonWithIcon
            iconType="arrow"
            iconSize={16}
            sx={{ padding: '10px 30px', fontWeight: 700 }}
            variant="primary"
            onClick={handleEnterApp}
            iconSx={{ ml: 0.5 }}
          >
            APPLICATION
          </ButtonWithIcon>
        </Link>
      </Grid>
    </Grid>
  );
}
